/**
 * Client-side helper: is the CSE currently in a live trading session?
 * CSE regular trading: 09:30 – 14:30 IST = 04:00 – 09:00 UTC, Mon–Fri.
 * An extra 30-min buffer on each end is applied so the UI feels responsive
 * just before open and just after close.
 */

const MARKET_HOLIDAYS: ReadonlySet<string> = new Set([
  // 2025
  '2025-01-14', '2025-01-15', '2025-02-04', '2025-02-26', '2025-03-13',
  '2025-04-01', '2025-04-14', '2025-04-18', '2025-04-30', '2025-05-01',
  '2025-05-12', '2025-05-21', '2025-06-06', '2025-07-10', '2025-08-08',
  '2025-08-19', '2025-10-02', '2025-10-20', '2025-12-25',
  // 2026
  '2026-01-14', '2026-01-15', '2026-02-04', '2026-03-02', '2026-04-01',
  '2026-04-03', '2026-04-13', '2026-04-14', '2026-05-01', '2026-05-28', 
  '2026-06-29', '2026-07-29', '2026-08-26', '2026-08-27', '2026-11-24',
  '2026-12-23', '2026-12-25',
]);

function todayISTDate(now: Date): string {
  // IST = UTC+5:30
  const istMs = now.getTime() + (5 * 60 + 30) * 60 * 1000;
  return new Date(istMs).toISOString().slice(0, 10);
}

/**
 * Returns true if tick worker is likely writing data right now.
 * Used to show the "LIVE" badge and enable intraday timeframes.
 */
export function isCSEMarketOpen(): boolean {
  const now = new Date();
  const day = now.getUTCDay(); // 0=Sun … 6=Sat
  if (day === 0 || day === 6) return false;

  const dateStr = todayISTDate(now);
  if (MARKET_HOLIDAYS.has(dateStr)) return false;

  // 03:30 – 09:30 UTC (30-min pre/post buffer around 04:00–09:00 window)
  const utcMinutes = now.getUTCHours() * 60 + now.getUTCMinutes();
  return utcMinutes >= 3 * 60 + 30 && utcMinutes <= 9 * 60 + 30;
}
